// Actions
const FETCH_ZCCS = 'zcc-controller/zccs/FETCH_ZCCS';
const FETCH_ZCCS_SUCCEEDED = 'zcc-controller/zccs/FETCH_ZCCS_SUCCEEDED';
const FETCH_ZCCS_FAILED = 'zcc-controller/zccs/FETCH_ZCCS_FAILED';

const ADD_ZCC = 'zcc-controller/zccs/ADD_ZCC';
const ADD_ZCC_SUCCEEDED = 'zcc-controller/zccs/ADD_ZCC_SUCCEEDED';
const ADD_ZCC_FAILED = 'zcc-controller/zccs/ADD_ZCC_FAILED';

const EDIT_ZCC = 'zcc-controller/zccs/EDIT_ZCC';
const EDIT_ZCC_SUCCEEDED = 'zcc-controller/zccs/EDIT_ZCC_SUCCEEDED';
const EDIT_ZCC_FAILED = 'zcc-controller/zccs/EDIT_ZCC_FAILED';

const CONFIRM_DELETE_ZCC = 'zcc-controller/zccs/CONFIRM_DELETE_ZCC';
const DELETE_ZCC = 'zcc-controller/zccs/DELETE_ZCC';
const DELETE_ZCC_SUCCEEDED = 'zcc-controller/zccs/DELETE_ZCC_SUCCEEDED';
const DELETE_ZCC_FAILED = 'zcc-controller/zccs/DELETE_ZCC_FAILED';

const START_ADDING_ZCC = 'zcc-controller/zccs/START_ADDING_ZCC';
const START_EDITING_ZCC = 'zcc-controller/zccs/START_EDITING_ZCC';
const CANCEL_ZCC = 'zcc-controller/zccs/CANCEL_ZCC';


export const initialState = {
  zccList: [],
  zccById: {},
  fetchZccsError: null,
  addZccError: null,
  editZccError: null,
  deleteZccError: null,
  addingZcc: false,
  editingZcc: undefined,
  deletingZcc: undefined
};

// Reducer
// eslint-disable-next-line complexity
const reducer = (state = initialState, action = {}) => {
  const { zccList, zccById } = state;
  let index;
  let list = [];
  let listById = {};

  switch (action.type) {
    case FETCH_ZCCS_SUCCEEDED:
      list = action.payload.map((zcc) => {
        listById[zcc._id] = zcc;
        return zcc._id;
      });
      return {...state, zccList: list, zccById: listById, fetchZccsError: null};
    case FETCH_ZCCS_FAILED:
      return {...state, fetchZccsError: action.payload};
    case ADD_ZCC_SUCCEEDED:
      listById = Object.assign({[action.payload._id]: action.payload}, zccById);
      return {...state, zccList: [...zccList, action.payload._id],
        zccById: listById, addZccError: null, addingZcc: false};
    case ADD_ZCC_FAILED:
      return {...state, addZccError: action.payload};
    case EDIT_ZCC_SUCCEEDED:
      listById = Object.assign({}, zccById, {[action.payload._id]: action.payload});
      return {...state, zccById: listById, editZccError: null, editingZcc: undefined};
    case EDIT_ZCC_FAILED:
      return {...state, editZccError: action.payload};
    case CONFIRM_DELETE_ZCC:
      return {...state, deletingZcc: action.payload._id};
    case DELETE_ZCC_SUCCEEDED:
      index = zccList.indexOf(action.payload._id);
      list = [...zccList.slice(0, index), ...zccList.slice(index + 1)];
      delete Object.assign(listById, zccById)[action.payload._id];
      return {...state, zccList: list, zccById: listById, deleteZccError: null, deletingZcc: undefined};
    case DELETE_ZCC_FAILED:
      return {...state, deleteZccError: action.payload, deletingZcc: undefined};
    case START_ADDING_ZCC:
      return {...state, addingZcc: true};
    case START_EDITING_ZCC:
      return {...state, editingZcc: action.payload._id};
    case CANCEL_ZCC:
      return {...state, addingZcc: false, editingZcc: undefined, deletingZcc: undefined};
    default: return state;
  }
};

// Action Creators
const fetchZccs = (payload) => {
  return { type: FETCH_ZCCS, payload };
};

const fetchZccsSucceeded = (payload) => {
  return { type: FETCH_ZCCS_SUCCEEDED, payload };
};

const fetchZccsFailed = () => {
  return { type: FETCH_ZCCS_FAILED };
};

const addZcc = (payload) => {
  return { type: ADD_ZCC, payload };
};

const addZccSucceeded = (payload) => {
  return { type: ADD_ZCC_SUCCEEDED, payload };
};

const addZccFailed = (payload) => {
  return { type: ADD_ZCC_FAILED, payload };
};

const editZcc = (payload) => {
  return { type: EDIT_ZCC, payload };
};

const editZccSucceeded = (payload) => {
  return { type: EDIT_ZCC_SUCCEEDED, payload };
};

const editZccFailed = (payload) => {
  return { type: EDIT_ZCC_FAILED, payload };
};

const deleteZcc = (payload) => {
  return { type: DELETE_ZCC, payload };
};

const confirmDeleteZcc = (payload) => {
  return { type: CONFIRM_DELETE_ZCC, payload };
};

const deleteZccSucceeded = (payload) => {
  return { type: DELETE_ZCC_SUCCEEDED, payload };
};

const deleteZccFailed = () => {
  return { type: DELETE_ZCC_FAILED };
};

const startAddingZcc = () => {
  return { type: START_ADDING_ZCC };
};

const startEditingZcc = (payload) => {
  return { type: START_EDITING_ZCC, payload };
};

const cancelZcc = () => {
  return { type: CANCEL_ZCC };
};

export default reducer;
export {
  // Actions
  FETCH_ZCCS, FETCH_ZCCS_SUCCEEDED, FETCH_ZCCS_FAILED,
  ADD_ZCC, ADD_ZCC_SUCCEEDED, ADD_ZCC_FAILED,
  EDIT_ZCC, EDIT_ZCC_SUCCEEDED, EDIT_ZCC_FAILED,
  CONFIRM_DELETE_ZCC, DELETE_ZCC, DELETE_ZCC_SUCCEEDED, DELETE_ZCC_FAILED,
  START_ADDING_ZCC, START_EDITING_ZCC, CANCEL_ZCC,
  // Action Creators
  fetchZccs, fetchZccsSucceeded, fetchZccsFailed,
  addZcc, addZccSucceeded, addZccFailed,
  editZcc, editZccSucceeded, editZccFailed,
  confirmDeleteZcc, deleteZcc, deleteZccSucceeded, deleteZccFailed,
  startAddingZcc, startEditingZcc, cancelZcc
};
